import React, { useEffect } from 'react';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import { deleteNullFields, sanitizeForm } from '../../../../core/util/form';
import PaperworkForm from '../../PaperworkForm';
import { SectionPage } from '~/components/Paperwork/interfaces';
import { usePreloadedData } from '../../hooks/usePreloadedData';
import PaperworkFields from '../../util/PaperworkFields';
import { useSolvSelector } from '~/reducers';

type Props = {
  form: formShape;
  onGoForward: () => void;
  handleClickNext: (newForm: GenericObj) => void;
  sectionPage: SectionPage;
};

const GenericSectionForm = (props: Props) => {
  const { form, handleClickNext, onGoForward, sectionPage } = props;

  const paperwork = useSolvSelector((state) => state.paperwork);
  const preloadedData = usePreloadedData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [paperwork.pageView]);

  const handleNextButtonClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    form.validateFields((errors: any, values: any) => {
      if (!errors) {
        const newForm = sanitizeForm(deleteNullFields(values));
        handleClickNext(newForm);
      }

      return null;
    });
  };

  return (
    <PaperworkForm
      form={form}
      onSkip={onGoForward}
      onSubmit={handleNextButtonClick}
      sectionPage={sectionPage}
    >
      <PaperworkFields
        fieldNames={sectionPage.fieldNames}
        form={form}
        preloadedData={preloadedData}
      />
    </PaperworkForm>
  );
};

export default createForm()(GenericSectionForm);
